import React, { useContext } from "react";
import gql from "graphql-tag";
import { useQuery } from "@apollo/client";
import MapCarousel from "components/MapCarousel";
import {
  BuildingPageQuery_buildingOrRedirect_building,
  BuildingPageQuery_buildingOrRedirect_building_listings,
} from "types/pages/building/BuildingPageQuery";
import MobileContext from "context/MobileContext";
import styles from "./styles.module.scss";

interface IImage {
  url: string;
  id: string;
}

interface IProps {
  selectedListing?: BuildingPageQuery_buildingOrRedirect_building_listings | null;
  building: BuildingPageQuery_buildingOrRedirect_building;
  displayAddress: string;
}

const BUILDING_IMAGES_QUERY = gql`
  query BuildingImages($slug: String!, $identity: ID) {
    buildingOrRedirect(slug: $slug, identity: $identity) {
      redirect
      building {
        id
        images2 {
          nodes {
            id
            url(size: "slideshow_small")
          }
        }
        listings {
          id
          images2 {
            nodes {
              id
              url(size: "slideshow_small")
            }
          }
        }
      }
    }
  }
`;

function notNull<T>(val: T | null): val is T {
  return val !== null;
}

const defaultImage = (isMobile: boolean) => [
  {
    url: isMobile
      ? "/nextpublic/zeroState-mobile@2x.png"
      : "/nextpublic/zeroState@2x.png",
    id: "000001",
  },
];

const BuildingImageCarousel = ({
  building,
  displayAddress,
  selectedListing,
}: IProps) => {
  const isMobileView = useContext(MobileContext); // use this over isTouch() or css checking. It can determine mobile user during ssr.

  const { data } = useQuery(BUILDING_IMAGES_QUERY, {
    variables: { slug: building.slug, identity: building.identity },
    fetchPolicy: "cache-only", // this is fetched in prerender. So read from cache. Gotcha - fields need to be present in query in pages/building/[...slug].tsx
  });

  const buildingImages =
    data?.buildingOrRedirect?.building?.images2?.nodes || [];

  const listingImages = selectedListing?.images2?.nodes || [];

  const initImages: IImage[] = listingImages
    .concat(buildingImages)
    .filter(notNull);

  const resovledDefaultImage = defaultImage(isMobileView);
  const staticMap: IImage[] = [];

  const lightboxImages = initImages.map(({ url, ...rest }) => ({
    ...rest,
    url: `${url.substring(0, url.length - 4)}-800`,
  }));

  return (
    <div className={styles.carouselContainer}>
      <MapCarousel
        images={initImages.length ? initImages : resovledDefaultImage}
        lightBoxImages={lightboxImages.length ? lightboxImages : resovledDefaultImage}
        address={displayAddress}
      />
    </div>
  );
};

export default BuildingImageCarousel;
